import {
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from "chart.js";
import React from "react";
import { Line } from "react-chartjs-2";

ChartJS.register(
  LineElement,
  PointElement,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  CategoryScale
);

const PitchPlot = ({
  initialTime = [],
  initialPitch = [],
  recordedTime = [],
  recordedPitch = [],
}) => {
  // Ensure the map is only called on valid arrays
  const initialPitchData =
    initialPitch.length > 0
      ? initialPitch.map((p, i) => ({ x: initialTime[i] || 0, y: p }))
      : [];
  const recordedPitchData =
    recordedPitch.length > 0
      ? recordedPitch.map((p, i) => {
          return { x: recordedTime[i] || 0, y: p };
        })
      : [];
  const data = {
    labels: initialTime, // Assuming both datasets share the same x-axis (time)
    datasets: [
      {
        label: "Initial Pitch Contour",
        data: initialPitchData,
        fill: false,
        backgroundColor: "rgba(75,192,192,1)",
        borderColor: "rgba(75,192,192,1)",
      },
      {
        label: "Recorded Pitch Contour",
        data: recordedPitchData,
        fill: false,
        backgroundColor: "rgba(153,102,255,1)",
        borderColor: "rgba(153,102,255,1)",
      },
    ],
  };

  const options = {
    scales: {
      x: {
        type: "linear",
        title: {
          display: true,
          text: "Time (s)",
        },
      },
      y: {
        title: {
          display: true,
          text: "Pitch (Hz)",
        },
      },
    },
    plugins: {
      legend: {
        position: "top",
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            return `Pitch: ${tooltipItem.raw.y.toFixed(2)}`;
          },
        },
      },
    },
  };

  return <Line data={data} options={options} />;
};

export default PitchPlot;
